<template>
  <vImage :sysId=eId :imgId=imgId />
</template>

<script>
import vImage from '@/components/common/ImageView.vue'
export default {
  name: 'poster',
  data() {
    return {
      imgId: 3,
      eId: 0
    }
  },
  components: {
    vImage
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    }
  },
  created () {
    this.eId = this.setting.enrollID[0].codeName;
  }
}
</script>

<style scoped> 
  
</style>



// WEBPACK FOOTER //
// src/components/PosterView.vue